export default __webpack_public_path__ + "static/media/US.32feac89.svg";